// components/RankPredictor.jsx
import { useState, useEffect } from "react";
import Link from "next/link";
import { getCookie } from "utils/index"; // Ensure correct import
import AOS from "aos";
import "aos/dist/aos.css";
import ResultModal from "@/components/homes/heros/ResultModal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import LoginPromptModal from "@/components/homes/heros/LoginPromptModal";
import ShowLoadingModal from "@/components/homes/heros/ShowLoadingModal";
import RankPredictorForm from "./RankPredictorForm";
// import sample from '../public/sample-predictor.png'; // Use your actual image path

const faqData = [
  {
    question: "How accurate is the NEET Rank Predictor?",
    answer: (
      <p>
        While the NEET Rank Predictor is highly accurate, it’s important to note
        that the final rank can be affected by variables like the total number
        of candidates and changes in exam difficulty.
      </p>
    ),
  },
  {
    question: "Does the predictor account for state quotas?",
    answer: (
      <p>
        Yes, our tool takes into account your category and state to give a more
        accurate prediction for your NEET rank.
      </p>
    ),
  },
  {
    question: "Can I use the tool even if I haven’t taken the NEET exam yet?",
    answer: (
      <p>
        Absolutely! You can use the tool with your predicted marks to get an
        estimate of your rank ahead of the exam.
      </p>
    ),
  },
  {
    question: "How often is the rank prediction data updated?",
    answer: (
      <p>
        The tool is updated annually to reflect the latest data and cut-off
        trends for the upcoming NEET exam year.
      </p>
    ),
  },
];

const tools = [
  {
    label: "6 Step Counselling",
    href: "https://portal.neetsupport.com/dashboard-Counselling",
  },
  {
    label: "Cut-off and Allotments",
    href: "https://portal.neetsupport.com/dashboard-cutoffs-allotments",
  },
  {
    label: "College Predictor",
    href: "https://portal.neetsupport.com/dashboard-College-Predictor",
  },
  {
    label: "Fees & Seat Matrix",
    href: "https://portal.neetsupport.com/dashboard-fees-seatmatrix",
  },
];


const rankComparisonData = [
  { marksRange: "720 – 700", rank2024: "1 – 1,640", rank2025: "0", rank2026: "1 – 19", difference: "↑ 19" },
  { marksRange: "699 – 650", rank2024: "1,641 – 27,368", rank2025: "2 – 77", rank2026: "20 – 1,492", difference: "↑ 1,415" },
  { marksRange: "649 – 630", rank2024: "27,369 – 36,833", rank2025: "78 – 147", rank2026: "1,493 – 2,354", difference: "↑ 2,207" },
  { marksRange: "629 – 600", rank2024: "36,834 – 77,972", rank2025: "148 – 1,411", rank2026: "2,355 – 10,160", difference: "↑ 8,749" },
  { marksRange: "599 – 571", rank2024: "77,973 – 1,11,730", rank2025: "1,412 – 5,318", rank2026: "10,161 – 22,969", difference: "↑ 17,651" },
  { marksRange: "570 – 528", rank2024: "1,11,731 – 1,66,836", rank2025: "5,319 – 25,711", rank2026: "22,970 – 57,820", difference: "↑ 32,109" },
  { marksRange: "527 – 518", rank2024: "1,66,837 – 1,80,358", rank2025: "25,712 – 34,109", rank2026: "57,821 – 67,818", difference: "↑ 33,709" },
  { marksRange: "517 – 516", rank2024: "1,80,359 – 1,82,949", rank2025: "34,110 – 35,930", rank2026: "67,819 – 70,285", difference: "↑ 34,355" },
  { marksRange: "515 – 506", rank2024: "1,82,950 – 1,96,986", rank2025: "35,931 – 45,970", rank2026: "70,286 – 81,908", difference: "↑ 35,938" },
  { marksRange: "505 – 500", rank2024: "1,96,987 – 2,05,888", rank2025: "45,971 – 52,694", rank2026: "81,909 – 90,470", difference: "↑ 37,776" },
  { marksRange: "499 – 477", rank2024: "2,05,889 – 2,40,369", rank2025: "52,695 – 82,134", rank2026: "90,471 – 1,23,081", difference: "↑ 40,947" },
  { marksRange: "476 – 475", rank2024: "2,40,370 – 2,43,551", rank2025: "82,135 – 85,027", rank2026: "1,23,082 – 1,24,935", difference: "↑ 39,908" },
  { marksRange: "474 – 454", rank2024: "2,43,552 – 2,76,866", rank2025: "85,028 – 1,16,380", rank2026: "1,24,936 – 1,60,143", difference: "↑ 43,763" },
  { marksRange: "453 – 427", rank2024: "2,76,867 – 3,23,836", rank2025: "1,16,381 – 1,61,265", rank2026: "1,60,144 – 2,11,095", difference: "↑ 49,830" },
  { marksRange: "426 – 411", rank2024: "3,23,837 – 3,53,597", rank2025: "1,61,266 – 1,90,196", rank2026: "2,11,096 – 2,46,962", difference: "↑ 56,766" },
  { marksRange: "410 – 401", rank2024: "3,53,598 – 3,73,240", rank2025: "1,90,197 – 2,09,258", rank2026: "2,46,963 – 2,70,591", difference: "↑ 61,333" },
  { marksRange: "400 – 389", rank2024: "3,73,241 – 3,97,525", rank2025: "2,09,259 – 2,32,963", rank2026: "2,70,592 – 3,01,167", difference: "↑ 68,204" },
  { marksRange: "388 – 380", rank2024: "3,97,526 – 4,16,417", rank2025: "2,32,964 – 2,51,682", rank2026: "3,01,168 – 3,26,194", difference: "↑ 74,512" },
  { marksRange: "379 – 373", rank2024: "4,16,418 – 4,31,341", rank2025: "2,51,683 – 2,66,347", rank2026: "3,26,195 – 3,46,214", difference: "↑ 79,867" },
  { marksRange: "372 – 361", rank2024: "4,31,342 – 4,58,124", rank2025: "2,66,348 – 2,92,357", rank2026: "3,46,215 – 3,79,598", difference: "↑ 87,241" },
  { marksRange: "360 – 349", rank2024: "4,58,125 – 4,86,398", rank2025: "2,92,358 – 3,19,526", rank2026: "3,79,599 – 4,17,812", difference: "↑ 98,286" },
  { marksRange: "348 – 341", rank2024: "4,86,399 – 5,05,729", rank2025: "3,19,527 – 3,38,316", rank2026: "4,17,813 – 4,46,714", difference: "↑ 1,08,398" },
  { marksRange: "340 – 312", rank2024: "5,05,730 – 5,80,672", rank2025: "3,38,317 – 4,11,474", rank2026: "4,46,715 – 5,48,955", difference: "↑ 1,37,481" },
  { marksRange: "311 – 287", rank2024: "5,80,673 – 6,52,369", rank2025: "4,11,475 – 4,82,605", rank2026: "5,48,956 – 6,49,747", difference: "↑ 1,67,142" },
];

export default function RankPredictor() {
  const [marks, setMarks] = useState("");
  const [activeFAQ, setActiveFAQ] = useState(null);

  const [predictedRanks, setPredictedRanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  // const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showRankPredictorForm, setShowRankPredictorForm] = useState(false);

  const authToken = getCookie("authToken"); // Retrieve auth token
  const isLoggedIn = !!authToken;

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 150,
      once: true,
    });
  }, []);

  const isLeadStillValid = () => {
    const itemStr = localStorage.getItem("leadSubmitted");
    if (!itemStr) return false;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem("leadSubmitted"); // Clean up expired
        return false;
      }
      return item.value === true;
    } catch (e) {
      localStorage.removeItem("leadSubmitted"); // Clean up corrupt data
      return false;
    }
  };

  const handleMarksSubmit = (e) => {
    e.preventDefault();
    const marksInt = parseInt(marks, 10);

    // Make sure toast container is rendered in your app, usually in _app.js or a layout file:
    // import { ToastContainer } from "react-toastify";
    // <ToastContainer />

    if (isNaN(marksInt) || marksInt < 1 || marksInt > 720) {
      toast.error("Please enter a valid NEET score between 1 and 720");
      return;
    }

    const leadSubmitted = isLeadStillValid();

    if (isLoggedIn || leadSubmitted) {
      handlePredictRank();
    } else {
      // setShowLoginPrompt(true);
      setShowRankPredictorForm(true);
    }
  };

  const handlePredictRank = async () => {
    setLoading(true);
    setShowLoadingModal(true);
    setPredictedRanks([]);

    try {
      // Store user lead in CRM
      const API_URL = process.env.NEXT_PUBLIC_API_URL;

      // Predict rank
      const response = await fetch(`${API_URL}/api/predict-rank`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(isLoggedIn && { Authorization: `Bearer ${authToken}` }),
        },
        body: JSON.stringify({
          marks: parseInt(marks, 10),
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const predictedRank = data.predicted_rank;
      const confidenceLower =
        predictedRank === 1 ? 1 : Math.max(1, Math.round(predictedRank - 25));
      const confidenceUpper = Math.round(predictedRank + 25);
      const confidenceRange = `${confidenceLower} - ${confidenceUpper}`;

      setPredictedRanks([
        {
          marks,
          predictedRank,
          confidenceRange,
          previousYearRanks: data.previousYearRanks || {},
        },
      ]);
      setTimeout(() => {
        setShowLoadingModal(false);
        setShowResultModal(true);
      }, 2000);
    } catch (error) {
      console.error("Error details:", error);
      toast.error(
        "Error predicting rank or submitting lead. Please try again."
      );
      setShowLoadingModal(false);
    } finally {
      setLoading(false);
    }
  };

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  // const handlePredict = () => {
  //     if (!marks) return alert('Please enter your marks');
  //     window.location.href = `/rank-result?marks=${marks}`;
  // };

  return (
    <>
      <ToastContainer />
      <div className="w-full flex flex-col">
        <div className="bg-[#005A53] min-h-[550px] md:min-h-[650px] w-full flex items-center justify-between px-10 2xl:px-40 pt-16 md:pt-12 flex-col md:flex-row">
          {/* Left Side */}
          <div className="text-white max-w-2xl md:w-1/2">
            <h1 className="text-2xl lg:text-4xl font-bold mb-4 text-center pt-16 md:pt-0">
              NEET Rank <span className="text-[#ff9245]">Predictor 2026</span>
            </h1>
            <p className="text-md lg:text-lg mb-8 font-medium text-center">
              Get your estimated NEET 2026 rank instantly. Just input your marks
              – no registration required!
            </p>
            <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl justify-center mx-auto ">
              <label className="block text-left text-gray-700 font-semibold mb-2">
                Marks
              </label>
              <form
                onSubmit={handleMarksSubmit}
                className="flex flex-col items-center"
              >
                <input
                  type="number"
                  placeholder="Enter Your NEET Score"
                  value={marks}
                  className="w-full border border-gray-300 p-3 rounded-md text-[#000] focus:ring-2 focus:ring-[#ff9245] outline-none"
                  onChange={(e) =>
                    setMarks(e.target.value.replace(/[^0-9]/g, ""))
                  }
                  data-aos="fade-up"
                  data-aos-delay="350"
                />
                {/* <div className="flex justify-center items-center"> */}
                <button
                  onClick={handleMarksSubmit}
                  type="submit"
                  data-aos="fade-up"
                  data-aos-delay="400"
                  disabled={loading}
                  className="px-6 mt-6 bg-[#FF9245] text-white  py-2 rounded-3xl
             hover:bg-white hover:ring-1 hover:ring-[#ff9245] hover:!text-[#ff9245]
             transition-colors duration-300 ease-in-out"
                >
                  {loading ? "Submitting..." : "Predict My Rank"}
                </button>

                {/* </div> */}
              </form>
            </div>
            {showLoadingModal && <ShowLoadingModal show={showLoadingModal} />}
            <ResultModal
              predictedRanks={predictedRanks}
              showResultModal={showResultModal}
              setShowResultModal={setShowResultModal}
            />
            {/* {showLoginPrompt && (
                            <LoginPromptModal
                              onClose={() => setShowLoginPrompt(false)}
                              tag="Rank Predictor"
                              marks={marks}
                            />
                          )} */}

            {showRankPredictorForm && (
              <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                <div className="relative">
                  <button
                    className="absolute top-0 sm:top-2 right-2 sm:right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                    onClick={() => setShowRankPredictorForm(false)}
                    aria-label="Close"
                  >
                    ×
                  </button>
                  <RankPredictorForm
                    onClose={() => setShowRankPredictorForm(false)}
                    tag="Rank Predictor"
                    marks={marks}
                    setPredictedRanks={setPredictedRanks}
                    showResultModal={showResultModal}
                    setShowResultModal={setShowResultModal}
                    setShowLoadingModal={setShowLoadingModal}
                    predictedRanks={predictedRanks}
                  />
                </div>
              </div>
            )}
          </div>

          {/* Right Side - Rank predictor animation */}
          <div className="hidden md:flex md:w-1/2 items-center justify-center px-5 lg:px-8 xl:px-10">
            <div className="rank-predictor-visual relative w-full max-w-[360px] [perspective:1200px] lg:max-w-[420px] xl:max-w-[460px]">
              {/* Soft ambient lighting */}
              <div
                aria-hidden="true"
                className="rank-predictor-glow absolute -inset-8 rounded-full bg-[#FF9245]/20 blur-3xl"
              />

              {/* Layered backplates create depth without extra assets */}
              <div
                aria-hidden="true"
                className="rank-predictor-layer-orange absolute inset-3 rounded-2xl bg-[#FF9245]/80 shadow-xl rotate-6 xl:rounded-[28px]"
              />
              <div
                aria-hidden="true"
                className="rank-predictor-layer-teal absolute inset-3 rounded-2xl border border-white/20 bg-[#08756c] shadow-xl -rotate-3 xl:rounded-[28px]"
              />

              <div className="group relative z-10 aspect-square overflow-hidden rounded-2xl bg-white/5 shadow-[0_28px_60px_-18px_rgba(0,0,0,0.55)] ring-1 ring-white/30 transition-all duration-500 ease-out [transform:rotateY(-5deg)_rotateX(2deg)] [transform-style:preserve-3d] hover:shadow-[0_32px_70px_-16px_rgba(0,0,0,0.65)] hover:[transform:rotateY(0deg)_rotateX(0deg)_translateY(-6px)] motion-reduce:transform-none motion-reduce:transition-none xl:rounded-[28px]">
                <div
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-tr from-black/10 via-transparent to-white/15"
                />
                <video
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                  width="1080"
                  height="1080"
                  aria-label="NEET Support rank predictor animation"
                  className="block h-full w-full object-cover"
                >
                  <source
                    src="/assets/video/neet_support_rank_predictor_animation.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>

          <style>{`
            .rank-predictor-visual {
              animation: rankPredictorFloat 5s ease-in-out infinite;
              will-change: transform;
            }

            .rank-predictor-glow {
              animation: rankPredictorGlow 4s ease-in-out infinite;
            }

            .rank-predictor-layer-orange {
              animation: rankPredictorOrangeLayer 6s ease-in-out infinite;
              transform-origin: center;
            }

            .rank-predictor-layer-teal {
              animation: rankPredictorTealLayer 6s ease-in-out infinite;
              transform-origin: center;
            }

            @keyframes rankPredictorFloat {
              0%,
              100% {
                transform: translate3d(0, 0, 0);
              }
              50% {
                transform: translate3d(0, -8px, 0);
              }
            }

            @keyframes rankPredictorGlow {
              0%,
              100% {
                opacity: 0.65;
                transform: scale(0.96);
              }
              50% {
                opacity: 1;
                transform: scale(1.04);
              }
            }

            @keyframes rankPredictorOrangeLayer {
              0%,
              100% {
                transform: rotate(6deg) translate3d(0, 0, 0);
              }
              50% {
                transform: rotate(8deg) translate3d(3px, -2px, 0);
              }
            }

            @keyframes rankPredictorTealLayer {
              0%,
              100% {
                transform: rotate(-3deg) translate3d(0, 0, 0);
              }
              50% {
                transform: rotate(-5deg) translate3d(-3px, 2px, 0);
              }
            }

            @media (prefers-reduced-motion: reduce) {
              .rank-predictor-visual,
              .rank-predictor-glow,
              .rank-predictor-layer-orange,
              .rank-predictor-layer-teal {
                animation: none;
              }
            }
          `}</style>
        </div>

        {/* Description Section */}

        <div className="mx-6 my-20 md:mx-16 xl:mx-40 2xl:mx-60 bg-white shadow-md rounded-xl p-6 sm:p-10 border border-gray-200">
          <section>
            <h2 className="text-2xl sm:text-4xl font-bold text-center mt-6 mb-10">
              Introduction
            </h2>
            <p className="text-gray-700 text-base sm:text-md leading-relaxed">
              Preparing for NEET UG is one of the most crucial steps in every
              medical aspirant’s journey. After months of hard work and
              dedication, the next big question that comes to every student’s
              mind is:{" "}
              <strong className="text-[#FF914D]">
                "What will be my NEET rank?"
              </strong>
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              To help you find the answer, <strong>NEET Support</strong> brings
              you the <strong>NEET UG Rank Predictor 2026</strong> – a free,
              easy-to-use, and accurate tool designed specifically for NEET UG
              candidates. Whether you have already appeared for the exam or are
              estimating your score before the results, this tool helps you
              predict your All India Rank (AIR) based on your marks, category,
              and state.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              The NEET Rank Predictor is built using the latest data and trends
              from previous years' NEET exams. It gives you an estimated rank
              range so you can plan your next steps confidently, including
              counselling preparation, college selection, and seat prediction.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              Understanding your expected NEET rank early gives you a
              significant advantage. You can shortlist potential colleges,
              analyze your chances for government or private medical seats, and
              prepare for counselling rounds in advance.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              Whether your goal is to get into a top government medical college
              or explore options under your state quota, the{" "}
              <strong>NEET Support Rank Predictor 2026</strong> is your starting
              point. It’s completely free, requires no registration, and
              delivers results within seconds.
            </p>
          </section>

          <section>
            <h2 className="text-2xl sm:text-4xl font-bold text-center mt-6 mb-10">
              What is the NEET Rank Predictor by{" "}
              <span className="text-[#FF914D]">NEET Support?</span>
            </h2>

            <p className="text-gray-700 text-base sm:text-md leading-relaxed">
              The <strong>NEET Rank Predictor</strong> by NEET Support is an
              online tool that helps students estimate their expected NEET UG
              2026 rank based on their exam marks, category, and state. This
              tool is designed for medical aspirants who want to understand
              where they stand in the competition before the official results
              are declared.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              The main goal of the NEET Rank Predictor is to give students a
              clear and realistic idea of their possible{" "}
              <strong>All India Rank (AIR)</strong>. By knowing your estimated
              rank early, you can start planning for NEET UG counselling,
              college choices, and seat allotment strategies well in advance.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-2">
              Key Features of NEET Support’s Rank Predictor:
            </h3>

            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                <strong>Free to Use:</strong> You don’t have to pay anything or
                sign up to use the tool. It’s completely free for every NEET
                aspirant.
              </li>
              <li>
                <strong>Easy to Use:</strong> The process is simple. Just enter
                your NEET marks, choose your state and category, and click on
                the "Predict My Rank" button. Within seconds, you’ll get your
                predicted rank.
              </li>
              <li>
                <strong>Data-Driven and Reliable:</strong> The tool uses the
                latest and most accurate data from previous NEET exams,
                including:
                <ul className="list-disc list-inside ml-5 mt-2 space-y-1">
                  <li>Past year NEET marks vs rank trends</li>
                  <li>Category-wise and state-wise cutoff data</li>
                  <li>
                    Total number of students who appeared in previous years
                  </li>
                </ul>
              </li>
            </ul>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              This combination of real data and smart algorithms helps make the
              prediction as accurate and useful as possible.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              Whether you are scoring high or looking to explore private or
              state quota seats, this tool gives you the clarity you need to
              make informed decisions about your next steps. It’s not just about
              estimating your rank — it’s about preparing smartly and staying
              ahead in the NEET UG 2026 journey.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              By using <strong>NEET Support's NEET UG Rank Predictor</strong>,
              you can reduce uncertainty and gain a competitive edge in your
              counselling preparation.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-4 mt-8">
              How to Use the NEET Rank Predictor?
            </h3>

            <p className="text-gray-700 text-base sm:text-md leading-relaxed">
              Using the <strong>NEET UG Rank Predictor 2026</strong> by NEET
              Support is quick, simple, and completely free. You don’t need to
              register, log in, or provide any personal details. The tool is
              designed to give you instant results with just a few basic inputs.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 font-semibold">
              Here’s a step-by-step guide to using the tool effectively:
            </p>

            <ul className="list-disc list-inside text-gray-700 space-y-2 mt-2">
              <li>
                <strong>Step 1: Enter Your NEET Marks</strong>
                <br />
                Start by entering your NEET UG 2026 score in the input box. This
                is the most important factor for predicting your rank. If you
                haven’t received your official result yet, you can also enter
                your expected marks based on your answer key.
              </li>
              <li>
                <strong>Step 2: Click on “Predict My Rank”</strong>
                <br />
                Once you’ve entered all the required information, click on the
                “Predict My Rank” button. In just a few seconds, the system will
                calculate and display your predicted NEET Rank.
              </li>
              <li>
                <strong>Step 3: View Your Estimated Rank Instantly</strong>
                <br />
                Your predicted rank will appear instantly on the screen — no
                login, no registration, and no waiting. This makes the process
                smooth and stress-free for every NEET aspirant.
              </li>
            </ul>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-4 mt-8">
              How is Your NEET Rank Calculated?
            </h3>

            <p className="text-gray-700 text-base sm:text-md leading-relaxed">
              The <strong>NEET UG Rank Predictor</strong> by NEET Support uses a
              smart, data-driven method to estimate your expected rank. The
              calculation is not random — it is based on a combination of
              multiple important factors that influence your actual NEET UG 2026
              rank.
            </p>

            <h4 className="text-lg font-medium text-gray-800 mt-4 mb-2">
              Key Elements Used to Predict NEET Rank:
            </h4>

            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                <strong>Marks Scored in NEET UG:</strong> Your total marks are
                the primary basis for calculating your rank. The higher your
                marks, the better your rank is likely to be.
              </li>
              <li>
                <strong>Reservation Category:</strong> Your category (General,
                OBC, SC, ST, EWS, etc.) plays a major role. Cutoffs vary across
                categories, so predictions are made accordingly.
              </li>
              <li>
                <strong>State of Domicile:</strong> Many states have state quota
                seats. The rank prediction considers your state to reflect local
                cutoff trends under the 85% state quota.
              </li>
              <li>
                <strong>Historical NEET Data:</strong> The predictor uses data
                from the last 3 NEET exams (2022, 2023, and 2024), including
                rank vs. marks trends, to match your score with similar past
                results.
              </li>
              <li>
                <strong>AI-Based Analysis:</strong> To improve accuracy, the
                predictor uses AI algorithms that analyze patterns from
                thousands of student records to give a realistic rank range.
              </li>
            </ul>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              This multi-factor model ensures the prediction is more than a
              guess — it is a well-informed estimate that helps students make
              better decisions for counselling and college planning.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-semibold mb-4 mt-8">
              Calculate Your NEET Rank with NEET Support Rank Predictor
            </h3>
            <ul className="list-disc list-inside text-gray-700">
              <p className="text-gray-700 text-base sm:text-md my-4 leading-relaxed font-semibold">
                NEET Rank Predictor – By NEET Support
              </p>
              <li>
                <strong>Enter Your Marks:</strong> [Your NEET score]
              </li>
            </ul>
            <p className="text-gray-700 mt-2">
              Click “Predict My Rank” to see your estimated rank and plan your
              next steps easily.
            </p>
          </section>

          <section>
            <h3 className="text-2xl font-semibold mb-2 mt-8 text-center">
              NEET UG 2026 Marks vs Rank Analysis
            </h3>
            <p className="text-center text-gray-600 mb-6">
              Score comparison based on NEET 2024, 2025 and 2026 trends
            </p>

            <div className="w-full overflow-x-auto rounded-xl border border-gray-300 shadow-sm">
              <table className="w-full min-w-[900px] text-sm text-gray-700">
                <thead className="bg-[#005F59] text-white">
                  <tr>
                    <th className="px-4 py-3 border border-[#0b746d] text-center">
                      Marks Range
                    </th>
                    <th className="px-4 py-3 border border-[#0b746d] text-center">
                      2024 Rank Range
                    </th>
                    <th className="px-4 py-3 border border-[#0b746d] text-center">
                      2025 Rank Range
                    </th>
                    <th className="px-4 py-3 border border-[#0b746d] text-center">
                      2026 Rank Range
                    </th>
                    <th className="px-4 py-3 border border-[#0b746d] text-center">
                      Difference (2026 vs 2025)
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {rankComparisonData.map((row, index) => (
                    <tr
                      key={row.marksRange}
                      className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 border border-gray-300 text-center font-semibold text-[#005F59] whitespace-nowrap">
                        {row.marksRange}
                      </td>
                      <td className="px-4 py-3 border border-gray-300 text-center whitespace-nowrap">
                        {row.rank2024}
                      </td>
                      <td className="px-4 py-3 border border-gray-300 text-center whitespace-nowrap">
                        {row.rank2025}
                      </td>
                      <td className="px-4 py-3 border border-gray-300 text-center font-semibold whitespace-nowrap">
                        {row.rank2026}
                      </td>
                      <td className="px-4 py-3 border border-gray-300 text-center font-semibold text-green-600 whitespace-nowrap">
                        {row.difference}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="mt-4 text-xs sm:text-sm text-gray-500 text-center">
              The first range starts from 720 marks because 720 is the maximum
              possible NEET UG score. Rank figures are trend-based estimates and
              may vary from the official result.
            </p>
          </section>

          {/* 6. Factors Affecting NEET 2026 Rank */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              Factors Affecting NEET 2026 Rank
            </h3>
            <p className="text-gray-700 text-base sm:text-md leading-relaxed">
              Your NEET rank is influenced by more than just your marks. Here
              are the key factors that will affect your final NEET UG 2026 rank:
            </p>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mt-4">
              <li>
                <strong>Total Number of Students Appearing:</strong> The higher
                the number of candidates in a given year, the more competition
                you face. If more students score high marks, your rank may be
                slightly lower even with a good score.
              </li>
              <li>
                <strong>Difficulty Level of the NEET Exam:</strong> If the exam
                is considered tough by most students, overall scores may be
                lower, and even a moderate score might result in a better rank.
                If the exam is easier, cutoffs and competition rise.
              </li>
              <li>
                <strong>Tie-Breaking Rules:</strong> If two students have the
                same marks, tie-breakers are applied. These include:
                <ul className="list-disc list-inside ml-5 mt-2 space-y-1">
                  <li>Higher marks in Biology</li>
                  <li>Higher marks in Chemistry</li>
                  <li>Fewer incorrect answers</li>
                  <li>Age (older candidate gets priority)</li>
                </ul>
              </li>
              <li>
                <strong>Category and State Quotas:</strong> General, OBC, SC,
                ST, and EWS categories have different cutoffs. States also have
                their own reservation rules and quota-based cutoffs for the 85%
                state quota. Your rank under state quota may differ from your
                All India Rank.
              </li>
            </ul>
            <p className="text-gray-700 mt-4">
              Understanding these factors helps you interpret your predicted
              NEET rank accurately and prepare better for college selection and
              counselling.
            </p>
          </section>

          {/* 7. Are NEET Rank Predictors 100% Accurate? */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              Are NEET Rank Predictors 100% Accurate?
            </h3>
            <p className="text-gray-700">
              No rank predictor can guarantee 100% accuracy, including NEET
              Support’s. However, it offers a highly reliable estimate based on
              real data and logical analysis.
            </p>
            <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
              <li>
                The prediction is based on previous years' NEET UG rank vs marks
                data, along with your category and state inputs.
              </li>
              <li>
                Factors like exam difficulty, number of test-takers, and
                tie-breaking rules can cause slight variation in the actual
                result.
              </li>
              <li>
                Still, NEET rank predictors are very useful for setting
                expectations, planning your NEET UG counselling strategy, and
                shortlisting medical colleges.
              </li>
            </ul>
            <p className="text-gray-700 mt-2">
              In short, while not 100% accurate, a good rank predictor gives you
              a strong starting point for your admission journey.
            </p>
          </section>

          {/* 8. Advantages of Using NEET Support Rank Predictor */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              Advantages of Using NEET Support Rank Predictor
            </h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                <strong>Completely Free & Instant:</strong> There’s no payment
                or registration required. Just enter your marks and basic
                details to get your result instantly.
              </li>
              <li>
                <strong>Personalized Prediction:</strong> It considers your
                reservation category (General, OBC, SC, ST, EWS) and state of
                domicile, giving you a customized rank estimate based on
                relevant cutoffs.
              </li>
              <li>
                <strong>No Login or Sign-Up:</strong> You can use the tool
                freely without creating an account, saving time and effort.
              </li>
              <li>
                <strong>Data-Backed & Updated:</strong> The tool uses real-time
                NEET UG trends and historical data to ensure accuracy and
                relevance.
              </li>
              <li>
                <strong>Mentally Prepares You for Counselling:</strong> Knowing
                your expected rank helps you plan ahead, reduce stress, and
                confidently approach state and AIQ counselling rounds.
              </li>
            </ul>
          </section>

          {/* 9. What to Do After Rank Prediction? */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              What to Do After Rank Prediction?
            </h3>
            <ul className="list-decimal list-inside text-gray-700 space-y-2">
              <li>
                <strong>Use the NEET College Predictor Tool:</strong> Find out
                which medical colleges you may get into based on your predicted
                rank, category, and state. This helps in building a target
                college list.
              </li>
              <li>
                <strong>Prepare Necessary Documents:</strong> Start gathering
                documents required for NEET UG counselling, such as:
                <ul className="list-disc list-inside ml-5 mt-1">
                  <li>NEET Admit Card & Scorecard</li>
                  <li>Domicile Certificate</li>
                  <li>Category Certificate (if applicable)</li>
                  <li>Class 10 & 12 Mark Sheets</li>
                  <li>Identity Proof</li>
                </ul>
              </li>
              <li>
                <strong>Shortlist Colleges Wisely:</strong> Use your predicted
                rank and preferences (location, fees, bond, infrastructure) to
                filter medical colleges for AIQ and State counselling rounds.
              </li>
              <li>
                <strong>Track Counselling Dates:</strong> Stay updated with the
                NEET UG 2026 counselling schedule released by MCC and your state
                medical authority.
              </li>
              <li>
                <strong>Attend Webinars by NEET Support Experts:</strong> Join
                NEET Support's expert sessions to understand the complete
                counselling process, cutoff trends, and how to make informed
                decisions.
              </li>
            </ul>
          </section>

          {/* 10. How NEET Support’s Rank Predictor Stands Out */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              How NEET Support’s Rank Predictor Stands Out ?
            </h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                <strong>Built for Accuracy:</strong> The tool uses a combination
                of current year trends, previous year cutoffs, and AI-driven
                algorithms to give more precise rank estimates.
              </li>
              <li>
                <strong>State-Specific Logic:</strong> Unlike generic
                predictors, it factors in state quota differences, giving you a
                better idea of your chances in your home state.
              </li>
              <li>
                <strong>Counselling-Integrated:</strong> The rank predictor is
                linked with NEET Support’s college predictor and counselling
                tools, guiding students from prediction to final admission.
              </li>
              <li>
                <strong>Verified by NEET Data Experts:</strong> All predictions
                are reviewed and fine-tuned by NEET counselling professionals
                who understand the variations in category-wise and round-wise
                cutoffs.
              </li>
              <li>
                <strong>Updated Every Year:</strong> The tool is refreshed with
                the latest NEET UG results, cutoffs, and counselling patterns to
                match the ongoing year’s trends.
              </li>
            </ul>
          </section>

          {/* 11. Predict Medical Colleges Using NEET Rank */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              Predict Medical Colleges Using NEET Rank
            </h3>
            <p className="text-gray-700">
              Once you have your predicted NEET UG 2026 rank, the next step is
              to find out which medical colleges you can get into. That’s where
              the <strong>NEET College Predictor 2026</strong> by NEET Support
              becomes your most valuable tool.
            </p>
            <p className="text-gray-700 mt-2">
              Using your estimated NEET rank, category, and state, the tool
              helps you shortlist MBBS colleges where you have a realistic
              chance of getting admission — whether under the All India Quota
              (AIQ) or the State Quota.
            </p>
            <p className="text-gray-700 mt-2">It analyzes:</p>
            <ul className="list-disc list-inside ml-5 text-gray-700 space-y-1">
              <li>Past year closing ranks</li>
              <li>Category-specific and round-wise cut-offs</li>
              <li>College type (Government, Private, Deemed)</li>
              <li>Tuition fees and seat availability</li>
            </ul>
            <p className="text-gray-700 mt-2">
              Whether you're targeting top government colleges or exploring
              private options, this tool gives you clarity and direction for
              your NEET counselling journey.
            </p>
          </section>

          {/* 12. NEET Rank Prediction vs Actual Rank: Past Comparisons */}
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              NEET Rank Prediction vs Actual Rank: Past Comparisons
            </h3>
            <p className="text-gray-700">
              Over the years, the NEET Support Rank Predictor has shown strong
              alignment with actual NEET ranks. Using past exam trends, we’ve
              helped thousands of students set the right expectations and plan
              accordingly.
            </p>
            <h4 className="text-lg font-medium text-gray-800 mt-4 mb-2">
              Historical Accuracy:
            </h4>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>
                For students scoring between 650–700, the predicted ranks in the
                tool had a <strong>98% match range</strong> with their actual
                All India Rank (AIR).
              </li>
              <li>
                Many students who used our rank prediction in 2023 and 2024
                reported that their actual NEET UG rank was within ±5% of the
                predicted range.
              </li>
            </ul>
          </section>
          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">Conclusion</h3>

            <p className="text-gray-700 text-base sm:text-md leading-relaxed">
              Getting an early idea of your <strong>NEET UG 2026 rank</strong>{" "}
              can completely change how you approach your counselling and
              college selection process. It removes the uncertainty and gives
              you a roadmap to follow.
            </p>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              With the <strong>NEET Rank Predictor by NEET Support</strong>, you
              can:
            </p>

            <ul className="list-disc list-inside text-gray-700 space-y-2 mt-2">
              <li>Estimate your AIR before results</li>
              <li>Know your standing across different categories and states</li>
              <li>Get mentally prepared for counselling rounds</li>
              <li>
                Plan documents, shortlist colleges, and attend expert-led
                webinars
              </li>
            </ul>

            <p className="text-gray-700 text-base sm:text-md mt-4 leading-relaxed">
              We recommend using both the <strong>NEET Rank Predictor</strong>{" "}
              and the <strong>NEET College Predictor</strong> to get a complete
              picture of your options and make informed decisions with
              confidence.
            </p>
          </section>

          <section>
            <h3 className="text-2xl font-semibold mb-4 mt-8">
              Related Resources
            </h3>
            <ul className="list-disc list-inside text-[#097F78] font-medium space-y-1">
              <li>
                <span
                  className="cursor-pointer hover:underline"
                  onClick={() =>
                    (window.location.href =
                      "https://neetsupport.com/counselling")
                  }
                >
                  NEET 2026 Counseling Process
                </span>
              </li>
              <li>
                <span
                  className="cursor-pointer hover:underline"
                  onClick={() =>
                    (window.location.href =
                      "https://neetsupport.com/blogs/expected-cut-off-and-safe-score-for-mbbs-and-bds-admission")
                  }
                >
                  NEET UG 2026 Expected Cutoff
                </span>
              </li>
              <li>
                <span
                  className="cursor-pointer hover:underline"
                  onClick={() =>
                    (window.location.href =
                      "https://neetsupport.com/blogs/neet-ug-result")
                  }
                >
                  NEET UG 2026 Results & Analysis
                </span>
              </li>
            </ul>
          </section>
        </div>

        <section className="mx-6 md:mx-16 xl:mx-40 2xl:mx-60  flex justify-center items-center ">
          <div className="bg-[#006666] py-10 px-4 w-full md:min-h-[200px] rounded-3xl">
            <h2 className="text-white text-2xl sm:text-3xl font-semibold text-center mb-6 underline underline-offset-4 decoration-white">
              Related Tools & Resources
            </h2>
            <div className="flex flex-wrap justify-center gap-6 xl:gap-12 mt-12">
              {tools.map((tool, index) => (
                <Link key={index} href={tool.href}>
                  <span className="inline-block bg-[#FF914D] text-white font-semibold px-5 py-2 rounded-md shadow hover:scale-105 transition-transform duration-200 cursor-pointer">
                    {tool.label}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full max-w-7xl mx-auto my-16 sm:mb-0">
          <h2
            className="sm:text-3xl text-2xl font-bold text-center capitalize"
            style={{ color: "#140342", fontSize: "28.125px" }}
          >
            Frequently asked <span className="text-[#ff9245]">questions</span>
          </h2>
          <div className="mt-8 space-y-4 ml-6 mr-6">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className={`p-4 border rounded-lg shadow-md ${
                  activeFAQ === index ? "bg-gray-50" : ""
                }`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center cursor-pointer">
                  <h3
                    className="text-lg font-semibold"
                    style={{ color: "#140342", fontSize: "16.875px" }}
                  >
                    {faq.question}
                  </h3>
                  <span>{activeFAQ === index ? "-" : "+"}</span>
                </div>
                <div
                  className={`mt-2 text-gray-600 text-left text-lg ${
                    activeFAQ === index ? "block" : "hidden"
                  }`}
                >
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
